import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServices } from 'src/app/Services/common.service';
import { ShiftModel } from '../../../../../../modules/information/shift';//'src/app/modules/information/shift';
import { ApiService } from '../../../../../../Services/api.service';//'src/app/Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';//'src/app/Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';//'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-edit-shift',
  templateUrl: './edit-shift.component.html',
  styleUrls: ['./edit-shift.component.css']
})
export class EditShiftComponent implements OnInit {
  shiftID: string;
  editShiftDataValue: any;
  enableForm = false;
  editShiftForm: FormGroup;
  public branchInformation=[];
  public fieldOptions=  [{  branch:[], isEnable:[{ name:"Active",value:'1'},{ name:"Inactive",value:'0'}]}];         // dropdown option object

  startTime: any;
  endTime: any;
  orgID: any;
  public updateValues=[];
  public finalCheck:boolean = false;

  public formObject = {
    shiftName: '',
    branch: '',
    startTime: '',
    endTime: '',
    isEnable: ''
  };
  public showBranch:boolean = false;
  public showStatus:boolean = false;
  public selectedBranch = [];
  public selectedStatus = [];

  constructor(
    public api: ApiService, 
    private formBuilder: FormBuilder,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute,
    public comService:CommonServices) {
      this.route.paramMap.subscribe((params: any) => {
        this.shiftID=params.params.shiftID;
      });
      this.orgID = this.storage.get('userInfo').orgID;
  }

  ngOnInit(): void {
    this.getBranchList();
    this.shiftFormLoad();
    setTimeout(()=>{ this.getEditList(); },300);
  }

  getEditList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      shiftID: this.shiftID
    };
    this.api.ListShift(obj).then((res: any) => {
      this.editShiftDataValue = res.data;
      this.setValueShiftData();

    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchList() {
    this.showBranch = false;
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      this.showBranch = true
      console.log(err);
    });
  }
  addBranchOptions(){
    if(this.branchInformation && this.branchInformation.length>0){
      this.branchInformation.filter((e)=>{
        let option={name:e.branchName,value:e.branchID};
        this.fieldOptions[0].branch.push(option);
      });
    }
    this.showBranch = true;
  }

  shiftFormLoad() {
    this.editShiftForm = this.formBuilder.group({
      shiftName: ['',Validators.required],
      branch: ['',Validators.required],
      startTime: ['',Validators.required],
      endTime: ['',Validators.required],
      isEnable: ['',Validators.required],
      isNodalShift_Login: [false],
      isNodalShift_Logout: [false]
    });

  }
  setValueShiftData() {
    this.editShiftForm.patchValue({
      shiftName: this.editShiftDataValue[0].shiftName?this.editShiftDataValue[0].shiftName:'',
      branch: this.editShiftDataValue[0].branch?this.editShiftDataValue[0].branch:'',
      isEnable: this.editShiftDataValue[0].isEnable == 0 ? this.editShiftDataValue[0].isEnable.toString():'1',
      startTime: this.editShiftDataValue[0].startTime ? this.editShiftDataValue[0].startTime:'00:00 AM',
      endTime:this.editShiftDataValue[0].endTime ? this.editShiftDataValue[0].endTime:'23:59 PM',
      isNodalShift_Login: this.editShiftDataValue[0].isNodalShift_Login ? this.editShiftDataValue[0].isNodalShift_Login : false,
      isNodalShift_Logout: this.editShiftDataValue[0].isNodalShift_Logout ? this.editShiftDataValue[0].isNodalShift_Logout : false
    });
    this.patchFormObject();
  }

  patchFormObject(){
    this.showBranch = false;
    this.showStatus = false;
    this.formObject = {
      shiftName: this.editShiftDataValue[0].shiftName?this.editShiftDataValue[0].shiftName:'',
      branch: this.editShiftDataValue[0].branch?this.editShiftDataValue[0].branch:'',
      isEnable: this.editShiftDataValue[0].isEnable == 0 ? this.editShiftDataValue[0].isEnable.toString():'1',
      startTime: this.editShiftDataValue[0].startTime ? this.time12to24(this.editShiftDataValue[0].startTime) : '00:00',
      endTime:this.editShiftDataValue[0].endTime ? this.time12to24(this.editShiftDataValue[0].endTime):'23:59',
    };
    this.selectedStatus = [];
    this.selectedBranch = [];
    this.selectedBranch.push(this.patchSelectedValue('branch',this.formObject.branch));
    this.selectedStatus.push(this.patchSelectedValue('isEnable',this.formObject.isEnable));
    setTimeout(()=>{  
      this.showStatus = true;
      this.showBranch = true;
    },200);
  }

  patchSelectedValue(field:any,value:any){
    let result = {}
    this.fieldOptions[0][field].filter((e)=>{ if(e.value==value) result = e;});
    return result;
  }

  searchSelectResult(field,e){      
    this.formObject[field] = e.value;
    this.editShiftForm.controls[field].patchValue(e.value);
    if(e.value) this.updateField(field,e.value);
  }

  patchFieldValue(field){
    let value = this.time24to12(this.formObject[field]);
    this.editShiftForm.controls[field].patchValue(value);
    if(value) this.updateField(field,value);
  }

  time12to24(time){
    let result = "00:00";
    let dateTime = new Date();
    let [hr,minMeriden] = time.split(':');
    let [min,meriden] = minMeriden.split(' ');
    if (hr === '12') hr = '00';
    if (meriden === 'PM') hr = parseInt(hr, 10) + 12;

    dateTime.setHours(hr,min);
    let hour = this.comService.pad(new Date(dateTime).getHours());
    let minute = this.comService.pad(new Date(dateTime).getMinutes());

    result = `${hour}:${minute}`;
    return result;
  }

  time24to12(time){
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      time = time.slice(1); 
      time[5] = +time[0] < 12 ? ' AM' : ' PM';
      time[0] = +time[0] % 12 || 12;
    }
    return time.join('');
  }

  /* update unique field*/
  fieldChange(e:any,type,field){

    if(type=='text' || type=='textarea'){
      this.updateField(field,e.target.value);
    }
    if(type=='time' || type=='dropdown'){
      this.updateField(field,e.value);
    }
    if(type=='checkbox'){
      this.updateField(field,e.target.checked);
    }
    
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
  }

   /* checking error in fields*/
   public checkError = (controlName: string, errorName: string) => {
    return this.editShiftForm.controls[controlName].hasError(errorName);
  } 
  

  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/list-shift']);
    this.editShiftForm.reset();
  }

  convert12HrsTo24Hrs(getTime:any){
    let final24Hrs:any='';
    const [time, modifier] = getTime.split(" ");
        let [hours, minutes] = time.split(":");
        if (hours === "12") {
            hours = "00";
        }
        if (modifier === "PM") {
            hours = parseInt(hours, 10) + 12;
        }
        final24Hrs = `${hours}:${minutes}`
        return final24Hrs;
    }

  onSubmit() {
    this.finalCheck = true;
    if (this.editShiftForm.valid){

      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        shiftID:this.shiftID,        
      };

      if(this.updateValues.length>0){
        this.updateValues.filter((e)=>{
          if (e.field == 'isEnable') obj[e.field] = Number(e.value);
          else obj[e.field]=e.value;
        });
        
        obj['startTime'] = this.convert12HrsTo24Hrs(this.editShiftForm.value.startTime);
        obj['endTime'] = this.convert12HrsTo24Hrs(this.editShiftForm.value.endTime);
        console.log(obj)
        this.api.UpdateShift(obj).then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 2000);
            this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/list-shift']);
          }
          if (res.status == 'failure') {
            this.swal.swalFunction('error', res.status, res.message, 2000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }

  }

  
  delete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteShift();
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }
  deleteShift() {
    const obj = {
      orgID: this.orgID,
      shiftID: this.shiftID
    };
    this.api.DeleteShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/list-shift']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
  }
}
